import clsx from "clsx";
import RichText from "./RichText";
import OverlayComponent from "./OverlayComponent";

export default function ServiceSideDrawer({
  service,
  clicked,
}: {
  service: {
    title?: string | null;
    description?: string | null;
  } | null;
  clicked: () => void;
}) {
  return (
    <OverlayComponent isOpen={service} closeCallback={clicked}>
      <div
        className={clsx([
          "flex h-full flex-col justify-center overflow-y-scroll px-15 md:pt-28 xl:py-52",
        ])}
      >
        {service && (
          <>
            {service.title && (
              <h2 className="w-fit text-heading-5">{service.title}</h2>
            )}
            {service.description && (
              <div className="mt-10 text-body">
                <RichText field={service.description} />
              </div>
            )}
          </>
        )}
      </div>
    </OverlayComponent>
  );
}
